import React__default from 'react';
import styled from 'styled-components';
import { Icon, __Icon } from '../icon/Icon.js';
import { getColor } from '../styles/stylePropTypes.js';
import { Text } from '../text/Text.js';

const TagElement = styled(Text)`
  align-items: center;
  border: 1px ${(props)=>props.border} ${(props)=>getColor(props.borderColor, props.theme)};
  border-radius: 0.25rem;
  background-color: ${(props)=>getColor(props.bgColor, props.theme)};
  color: ${(props)=>getColor(props.$color, props.theme)};
  display: inline-flex;
  line-height: 1.5rem;
  margin: -0.25rem 0 -0.125rem;
  min-width: auto;
  padding: 0.5rem;
  width: fit-content;
  height: 1.5rem;

  && > [${Icon.dataId}] {
    margin-right: 0.25rem;
  }

  &:hover,
  &:focus {
    background-color: ${(props)=>getColor(props.bgColor, props.theme)};
  }

  &:after {
    content: '';
    /* Remove clearfix hack style from button component */
    content: '';
  }
`;
/**
 * Simple tag component.
 * Aligns baseline of bordered text with surrounding text.
 *
 * Assumes a border color based on the given border prop.
 * If no borderColor is given, the color is used.
 */ const Tag = ({ bgColor ="slateGrey10" , border ="solid" , borderColor ="transparent" , color ="slateGreyDark50" , icon =undefined , iconColor ="slateGreyDark50" , children , ...props })=>{
    if (!borderColor) {
        borderColor = border === "none" ? bgColor : color;
    }
    // To keep tag sizes consistent, a tag with border set to 'none' actually will have a solid border
    if (border === "none") {
        border = "solid";
    }
    return React__default.createElement(TagElement, {
        "data-hpy-web-tag": true,
        size: "medium",
        weight: "bold",
        ...props,
        "$color": color,
        bgColor: bgColor,
        borderColor: borderColor,
        border: border
    }, !!icon && React__default.createElement(__Icon, {
        icon: icon,
        size: 0.5,
        color: iconColor
    }), children);
};
Tag.dataId = "data-hpy-web-tag";
Tag.displayName = "Tag";

export { Tag };
